<template lang="pug">
    div(class="journal-section" style="position:relative;")
        div(class="" style="overflow-y:scroll; border:0px solid;height:90%; background-color:white;border-radius: 0 0 5px 5px")
            div(class="journal-content" style="")
                div(v-if="insiders.length<1")
                    v-simple-table(class="mb-0" style="font-weight: bold;" dense)
                        template(v-slot:default)
                            thead(class="yellow2")
                                tr
                                    th(class="text-left" style="border:0" width="110") Date
                                    th(class="text-left" style="border:0") Note

                    div(class="mt-3 pt-10 text-center" style="width: 60%; margin: 0 auto;font-size: 14px; font-weight: 300; color: rgba(0,0,0,.5)")
                        div(style="") {{this.$t('any_journal')}}
                            <h5>{{stockData.name}}</h5>

                div(v-else style="overflow-y:scroll; height:480px; border:0px solid;")
                    v-simple-table(dense class="mb-0")
                        template(v-slot:default)
                            thead(class="yellow2" style="height:35px")
                                tr
                                    th(class="text-left" style="border-bottom:0;" width="110") Date
                                    th(class="text-left" style="border-bottom:0;" width="70") Note
                                    th(class="text-left" style="border-bottom:0;" width="70")
                                    th(class="text-left" style="border-bottom:0;" width="160")
                                    th(class="text-left" style="border-bottom:0;")
                                    th(class="text-left" style="border-bottom:0;")
                                    th(style="border-bottom:0;")
                            tbody
                                tr(v-for="(item, index) in insiders" :key="'tr_'+index" :style="{backgroundColor: removeHoverEffect ? 'white' : ''}")
                                    td(v-show="item.type === 'diary'" class="hover-item" :style="`background-color:${item.background};`" style="border-bottom: 1px solid lightgrey;")
                                        span(@click="selectHere($event, item.diary_item_id)" style="border:0px solid;") {{item.date_created}}
                                    td(v-show="item.type === 'diary'" colspan="5" :style="{background: item.background, borderBottom: '1px solid lightgrey', padding: '0', margin: '0'}" class="tdNote hover-item not-close-palette pl-4 pr-4" style="position:relative;")
                                        span(@click="selectNoteTextElement($event, item.diary_item_id)" :id="'noteLabelSelect' + item.diary_item_id" class="one-liner" style="position:absolute; top:0; float:left; width:calc(100% - 20px); height:100%; padding-top:5px; border:0px solid;" :title="item.note") {{item.note_first_line}}
                                    td(v-show="item.type === 'diary'" @mouseover="removeHoverEffect = true" @mouseout="removeHoverEffect = false" @click="removeJournalNote(item.diary_item_id)" :style="`background-color:${item.background};`" style="width:35px; padding:0;")
                                        v-list-item-icon(class="ml-1 mt-0 mr-0 mb-0" style="border-left:1px solid #333333;")
                                            v-icon(class="hover-trash-can-new") $trashCanNew
                                            //- v-icon(class="hover-trash-can") $trashCan

                                    td(v-show="item.type !== 'diary'") {{ item.date }}
                                    td(v-show="item.type !== 'diary'") {{ item.tx_type }}
                                    td(v-show="item.type !== 'diary'" style="text-align:right;") {{ item.amount }}
                                    td(v-show="item.type !== 'diary'") @ {{ item.price }} {{ item.currency }}
                                    td(v-show="item.type !== 'diary'")
                                    td(v-show="item.type !== 'diary'" style="text-align:right;") {{ item.account_name }}
                                    td(v-show="item.type !== 'diary'")

        div(class="mt-3" style="display: flex;")

            textarea-autosize(
                placeholder="Start writing a note..."
                ref="myTextarea"
                v-model="textAreaText"
                rows="1"
                :max-height="36"
                class="mr-3"
                style="background-color:#fff; width:100%; resize:none; outline:0px !important; border-radius:4px; padding:10px; border:0px solid;"
            )
            v-btn(@click="addTradeJournal" depressed class="btn-primary" style="") {{ $t('add_notes') }}

        EditJournalDate(v-if="showEditDate" @updateChart="emitUpdateChart" :insider="diary" :top="posY" ref="myEditDateElement")
        EditJournalNoteAndColor(v-if="showEditNote" @updateChart="emitUpdateChart" ref="myEditJournalNoteAndColorElement" :insider="diary" :top="posY")
</template>

<script>
import ColorPicker from './ColorPicker';
import EditJournalDate from './EditJournalDate';
import EditJournalNoteAndColor from './EditJournalNoteAndColor';
import { mapGetters, mapActions, mapMutations } from "vuex";
import apiService from "@/Services/ApiService";
import moment from 'moment';
import _ from 'lodash';

const helper = require('./../util/helper');

export default {
    name: 'Journal',
    props: {
        stock_id: {
            type: Number,
        }
    },
    components: {
        ColorPicker,
        EditJournalDate,
        EditJournalNoteAndColor
    },
    data() {
        return {
            posY: 0,
            showEditDate: false,
            showEditNote: false,
            diary: null,
            windowsWidth: 0,
            windowsHeight: 0,
            selectedColor: null,
            userId: JSON.parse(localStorage.getItem('user')).user_id,
            removeHoverEffect: false,
            showColorSelector: false,
            backgroundColors: ["#C2E0FC", "#C9FDCE", "#FFFFBA", "#FAE0BF", "#F4B6BB"],
            colorSelected: null,
            diaryItemId: null,
            numberOfRows: 1,
            textAreaText: ''
        };
    },
    async mounted() {
        await this.loadTx(this.userId);
        //  WHY ARE WE LOADING HERE ? TOO LATE ... TOO MANY HOLES.

        this.windowsWidth = window.innerWidth;
        this.windowsHeight = window.innerHeight;

        window.addEventListener('click', this.close);
        window.addEventListener('resize', this.setWindowDimensions);
    },
    beforeDestroy() {
        window.removeEventListener('click', this.close);
        window.removeEventListener('resize', this.setWindowDimensions);
    },
    computed: {
        ...mapGetters([
            'getTx',
            'getMapUserDiary',
            'getTrade',
            'getAllStocks',
            'getMapStocks',
            'getUserAccounts'
        ]),
        stockData() {
            return this.getMapStocks.find(s => s.stock_id == this.stock_id);
        },
        insiders() {
            let data = [];
            let diary = this.getMapUserDiary.filter(item => item.stock_id === this.stock_id);

            // console.log('diary', diary);

            diary = diary.map((i) => {
                const note = this.showOnlyFirstLine(i.note);

                i.note_first_line = note;

                return i;
            });

            diary.map((item) => {
                data.push(Object.assign({}, item, {type: 'diary'}, {date: item.date_created}));
            });

            let tx = this.txData.map((x) => {
                x.account_name = this.getUserAccounts.find((a) => a.user_account_id === x.user_account_id).account_name;
                x.date = x.tx_date;
                x.type = 'tx';

                return x;
            });

            tx = tx.filter((x) => x.tx_type !== 'DIVIDEND');

            data = data.concat(tx);

            data = _.orderBy(data, ['date'], ['desc']);

            return data;
        },
        txData() {
            const tx = this.getTx.filter((x) => x.stock_id === this.stock_id);

            return tx;
        },
        userTradesFinished() {
            const userTrades = this.getTrade;
            // console.log(userTrades);
            const userTradesOnStock = userTrades.filter((tx) => tx.stock_id === this.stock_id);
            // console.log(userTradesOnStock);
            const userTradesFinished = userTradesOnStock.filter((tx) => tx.exit_date !== null && tx.exit_price !== null && tx.exit_qty !== null);
            // console.log(userTradesFinished);

            return userTradesFinished;
        },
        gains() {
            let entryCostSum = 0;
            let exitProfitSum = 0;

            for(const trade of this.userTradesFinished) {
                entryCostSum += (trade.entry_price * trade.entry_qty);
                exitProfitSum += (trade.exit_price * trade.exit_qty);
            }

            const pnl = helper.thousandFormatter((exitProfitSum - entryCostSum).toFixed(0));

            return pnl;
        },
        totalCapitalGains() {
            let entryCostSum = 0;
            let exitProfitSum = 0;

            for(const trade of this.userTradesFinished) {
                entryCostSum += (trade.entry_price * trade.entry_qty) + trade.entry_commission;
                exitProfitSum += (trade.exit_price * trade.exit_qty) - trade.exit_commission;
            }

            const pnl = helper.thousandFormatter((exitProfitSum - entryCostSum).toFixed(0));

            return pnl;
        },
        dividendsData() {
            const dividends = this.txData.filter((tx) => tx.tx_type === 'DIVIDEND');

            return dividends;
        },
        totalDividends() {
            let totalSum = 0;

            for(const dividend of this.dividendsData) {
                totalSum += dividend.price * dividend.qty;
            }

            return helper.thousandFormatter(totalSum);
        },
        totalCommissions() {
            let commissionsSum = 0;

            for(const trade of this.userTradesFinished) {
                commissionsSum += (trade.entry_commission + trade.exit_commission);
            }

            return commissionsSum;
        },
        firstEntry() {
            // console.log('firstEntry');
            // console.log(this.userTradesFinished);
            if(this.userTradesFinished.length > 0) {
                const firstEntryDate = _.minBy(this.userTradesFinished, 'entry_date').entry_date;
                return firstEntryDate;
            }

            return 'No date';
        },
        timeDiffOnFirstEntry() {
            // console.log('timeDiffOnFirstEntry');
            // console.log(this.userTradesFinished);
            if(this.userTradesFinished.length > 0) {
                const firstEntryDate = _.minBy(this.userTradesFinished, 'entry_date').entry_date;
                return helper.getTimeDiff(firstEntryDate);
            }

            return 'No time diff';
        },
        averageHolding() {
            const diffDaysArray = [];

            for(const trade of this.userTradesFinished) {
                const diffDays = moment(trade.exit_date).diff(trade.entry_date, 'days');

                diffDaysArray.push(diffDays);
            }

            let sumOfDiffDays = 0;

            for(const days of diffDaysArray) {
                sumOfDiffDays += days;
            }

            const averageDiffDays = (sumOfDiffDays / diffDaysArray.length).toFixed(0);

            return averageDiffDays;
        },
        currency() {
            const currency = this.getAllStocks.find((s) => s.stock_id === this.stock_id).currency_trade;

            return currency;
        }
    },
    methods: {
        ...mapActions([
            'loadTx',
            'loadTrade'
        ]),
        ...mapMutations([
            'updateMapUserDiaryItem',
            'removeMapUserDiaryItem',
            'addMapUserDiaryItem',
            'setRegisterType',
            'setRegisterWindows'
        ]),
        insertLineBreakFromText(text) {
            return text.replace(/\n/g, '<br />');
        },
        showOnlyFirstLine(text) {
            const firstLineOfText = text.split('\n').length > 1 ? `${text.split('\n')[0]}...` : text.split('\n')[0];

            // console.log(firstLineOfText);

            return firstLineOfText;
        },
        emitUpdateChart() {
            this.$emit('updateChart');
        },
        setWindowDimensions() {
            this.windowsWidth = window.innerWidth;
            this.windowsHeight = window.innerHeight;
        },
        closeColorPicker() {
            this.$refs.colorPicker.closeColorPicker();
        },
        useColorPicker(item, event) {
            this.$refs.colorPicker.openColorPicker();
            this.$refs.colorPicker.setClickedNote(item);

            const colorPickerElement = this.$refs.colorPicker.$el;
            const element = event.target;
            const bottom = element.parentNode.offsetTop;
            const left = element.parentNode.offsetLeft;

            colorPickerElement.style.top = `${bottom + 90}px`;
            colorPickerElement.style.left = `${left + 45}px`;

            this.selectedColor = item.background.trim();
        },
        async saveNote(event) {
            const diaryItemId = parseInt((event.target.id).substr(14));
            const textElement = document.getElementById('noteTextSelect' + diaryItemId);
            const selectedElement = document.getElementById('noteLabelSelect' + diaryItemId);
            const textValue = textElement.value;

            const data = {
                diary_item_id: diaryItemId,
                note: textValue
            };

            await apiService.updateDiaryItem(data);

            this.updateMapUserDiaryItem(Object.assign({}, data, { key: 'note' }));

            textElement.style.display = 'none';
            selectedElement.style.display = 'block';

            this.$emit('updateChart');
        },
        selectNoteTextElement(event, diary_item_id) {
            this.diary = this.insiders.find((i) => i.diary_item_id === diary_item_id);

            // console.log(diary_item_id);
            // console.log(event.target);
            // console.log(this.diary);

            this.showEditNote = true;
            this.posY = event.clientY;

            setTimeout(() => {
                // console.log(this.$refs.myEditJournalNoteAndColorElement.$refs.textAreaElement);

                const textAreaElement = this.$refs.myEditJournalNoteAndColorElement.$refs.textAreaElement;

                textAreaElement.focus();
            }, 200);

            // console.log(this.posY);
        },
        async removeJournalNote(diaryItemId) {
            await apiService.deleteDiaryItem(diaryItemId);

            this.removeMapUserDiaryItem(diaryItemId);

            this.$emit('updateChart');
        },
        removeEditText() {
            for(const item of this.insiders) {
                const textElement = document.getElementById('edit' + item.diary_item_id);
                const labelElement = document.getElementById('select' + item.diary_item_id);

                textElement.value = item.date_created;
                textElement.style.display = 'none';

                labelElement.style.display = 'block';
            }
        },
        async saveDate(event) {
            const diaryItemId = parseInt((event.target.id).substr(4));
            const textElement = document.getElementById('edit' + diaryItemId);
            const selectedElement = document.getElementById('select' + diaryItemId);
            const textValue = textElement.value;

            const data = {
                diary_item_id: diaryItemId,
                date_created: textValue
            };

            await apiService.updateDiaryItem(data);

            this.updateMapUserDiaryItem(Object.assign({}, data, { key: 'date_created' }));

            textElement.style.display = 'none';
            selectedElement.style.display = 'block';

            this.$emit('updateChart');
        },
        selectHere(event, diary_item_id) {
            this.diary = this.insiders.find((i) => i.diary_item_id === diary_item_id);
            this.posY = event.clientY;

            // console.log(this.posY);
            // console.log(this.diary);

            this.showEditDate = true;

            setTimeout(() => {
                // console.log(this.$refs.myEditDateElement.$refs.dateInputElement);

                const dateInputElement = this.$refs.myEditDateElement.$refs.dateInputElement;

                dateInputElement.focus();
            }, 200);
        },
        async addTradeJournal() {
            // Open register popup if visitor
            if(this.userId === 0) {
                this.setRegisterType('signup');
                this.setRegisterWindows(true);

                return;
            }

            try {
                if(this.textAreaText !== '') {
                    const diaryItem = {
                        user_id: this.userId,
                        stock_id: this.stock_id,
                        date_created: new Date().toISOString().substring(0, 10),
                        note: this.textAreaText,
                        background: '#FFFFBA'
                    };

                    const response = (await apiService.insertDiaryItem(diaryItem)).data;

                    this.addMapUserDiaryItem(response);

                    this.textAreaText = '';

                    this.$emit('updateChart');
                } else {
                    this.$store.commit('setMessage', { text: "You haven't added any text yet", type: 'error' });
                }
            } catch (error) {
                console.log(error.message);
            }
        }
    }
}
</script>

<style scoped>
.v-btn {
    text-transform: none;
}

.v-icon:hover {
    cursor: pointer;
    color: red;
}

.hover-item:hover {
    cursor: pointer;
}

.colorBox:hover {
    cursor: pointer;
    border: 1px solid grey;
}

#colorSelector {
    position: absolute;
    background-color: white;
}

>>> .set-trash-can-container {
    width: 20px;
    height: 20px;
}

>>> .set-trash-can-color {
    stroke: #333333;
}

>>> .hover-trash-can:hover .set-trash-can-color {
    fill: red;
}

>>> .set-trash-can-new-container {
    width: 24px;
    height: 24px;
}

>>> .set-trash-can-new-color {
    fill: #000000;
}

>>> .hover-trash-can-new:hover .set-trash-can-new-color {
    fill: red;
}

.one-liner {
    max-width: calc(100% - 20px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>
